<div class="card" [ngClass]="class">
  <div class="card-body">
    <div *ngIf="meta" class="metatitle">{{meta}}: </div>
    <h5 *ngIf="title"> {{title}}</h5>
    <hr *ngIf="divider" />
    <ng-content></ng-content>
  </div>
</div>